import { api } from '@cwd/lib/main';

export interface ApiKeySummary {
    ApiKeyId: string;
    Name: string;
    Expiry: string;
    AccountId: string;
    Account: string;
    UserName: string;
    UserUserName: string;
    IsExpired: boolean;
}

export async function getApiKeys(includeInactive = false): Promise<ApiKeySummary[]> {
    return api.get('/ApiKeys?includeInactive=' + includeInactive);
}

export async function createApiKey(name: string): Promise<{ Key: string }> {
    return api.post('/ApiKeys', name);
}

export async function disableApiKey(apiKeyId: string): Promise<void> {
    return api.post('/ApiKeys/' + apiKeyId + '/disable');
}
